import { SavedFilters } from 'utils/filters';
import apiRequest from './requestBase';

export async function getSavedFilterSets() {
  return apiRequest({
    url: '/api/alltrails/v2/saved_filters'
  });
}

export async function saveFilterSet(name: string, filters: SavedFilters) {
  return apiRequest({
    data: {
      name,
      filters
    },
    method: 'POST',
    url: '/api/alltrails/v2/saved_filters'
  });
}

export async function deleteSavedFilterSet(id: number) {
  return apiRequest({
    method: 'DELETE',
    url: `/api/alltrails/v2/saved_filters/${id}`
  });
}
